export default{
    // general
    "clinics.clinicDetails.redirecting" : "Redirection en cours...",
    "clinics.clinicDetails.list"        : "Liste de stages",
    "clinics.clinicDetails.404"         : "Cette page de stage a été supprimée, déplacée ou n'existe pas.",
}